import api from "./api";

export const fetchRewardPage = (params, options = {}) => api.get("/recompensas/catalogo", { ...options, params });

export async function fetchRewardsByIds(ids, { admin = false } = {}) {
  const rewards = [];
  const identifiers = [...new Set(ids.filter(Boolean))];
  for (let offset = 0; offset < identifiers.length; offset += 48) {
    const response = await fetchRewardPage({ ids: identifiers.slice(offset, offset + 48).join(","), limite: 48, incluir_inativas_erp: admin });
    rewards.push(...response.data.itens);
  }
  return { data: rewards };
}
